import React from 'react'
import '../../styles/gallery/main.css';

const Main = () => {
    return (
        <div>
            <section className="gallery-main">
                <div className="container">
                    <h1 className="my-heading mb-3">SPORTS GALLERY</h1>
                    <ul>
                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle" role="button" className="btn-gallery">
                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/archery/1.jpg"
                                    alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle" role="button">View More</a>
                            <div>
                                <h6>Archery</h6>
                            </div>
                        </li>

                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle2" role="button" className="btn-gallery">
                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Basket-Ball/1.jpg"
                                    alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle2" role="button">View More</a>
                            <div>
                                <h6>Basket Ball</h6>
                            </div>
                        </li>

                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle3" role="button" className="btn-gallery">
                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Bedminton/1.jpg"
                                    alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle3" role="button">View More</a>
                            <div>
                                <h6>Badminton</h6>
                            </div>
                        </li>

                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle4" role="button" className="btn-gallery">
                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cricket/1.jpg"
                                    alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle4" role="button">View More</a>
                            <div>
                                <h6>Cricket</h6>
                            </div>
                        </li>

                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle5" role="button" className="btn-gallery">
                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Gym/1.jpg"
                                    alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle5" role="button">View More</a>
                            <div>
                                <h6>Gym</h6>
                            </div>
                        </li>

                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle6" role="button" className="btn-gallery">
                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Self-Defence/1.jpg"
                                    alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle6" role="button">View More</a>
                            <div>
                                <h6>Self Defence</h6>
                            </div>
                        </li>

                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle7" role="button" className="btn-gallery">
                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Table-tennis/1.jpg"
                                    alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle7" role="button">View More</a>
                            <div>
                                <h6>Table Tennis</h6>
                            </div>
                        </li>

                        <li>
                            <a data-bs-toggle="modal" href="#exampleModalToggle8" role="button" className="btn-gallery">
                                <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Yoga/1.jpg"
                                    alt="gallery" />
                            </a>
                            <a className="view_more_btn" data-bs-toggle="modal" href="#exampleModalToggle8" role="button">View More</a>
                            <div>
                                <h6>Yoga</h6>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>

            <div className="modal-main">
                <div className="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                    tabindex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/archery/1.jpg"
                                            className="d-block w-100" alt="archery" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/archery/2.jpg"
                                            className="d-block w-100" alt="archery" />
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls"
                                    data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls"
                                    data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                <div className="close-btn-modal">
                                    <button data-bs-dismiss="modal" aria-label="Close">
                                        <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-main">
                <div className="modal fade" id="exampleModalToggle2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                    tabindex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselExampleControls2" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Basket-Ball/1.jpg"
                                            className="d-block w-100" alt="Basket Ball" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Basket-Ball/2.jpg"
                                            className="d-block w-100" alt="Basket Ball" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Basket-Ball/3.jpg"
                                            className="d-block w-100" alt="Basket Ball" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Basket-Ball/4.jpg"
                                            className="d-block w-100" alt="Basket Ball" />
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls2"
                                    data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls2"
                                    data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                <div className="close-btn-modal">
                                    <button data-bs-dismiss="modal" aria-label="Close">
                                        <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-main">
                <div className="modal fade" id="exampleModalToggle3" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                    tabindex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselExampleControls3" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Bedminton/1.jpg"
                                            className="d-block w-100" alt="Bedminton" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Bedminton/2.jpg"
                                            className="d-block w-100" alt="Bedminton" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Bedminton/3.jpg"
                                            className="d-block w-100" alt="Bedminton" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Bedminton/4.jpg"
                                            className="d-block w-100" alt="Bedminton" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Bedminton/5.jpg"
                                            className="d-block w-100" alt="Bedminton" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Bedminton/6.jpg"
                                            className="d-block w-100" alt="Bedminton" />
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls3"
                                    data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls3"
                                    data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                <div className="close-btn-modal">
                                    <button data-bs-dismiss="modal" aria-label="Close">
                                        <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-main">
                <div className="modal fade" id="exampleModalToggle4" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                    tabindex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselExampleControls4" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Cricket/1.jpg"
                                            className="d-block w-100" alt="Cricket" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpeg/2025/04/sports/sports1-9-4-25.jpeg"
                                            className="d-block w-100" alt="Cricket" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpeg/2025/04/sports/sports2-9-4-25.jpeg"
                                            className="d-block w-100" alt="Cricket" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpeg/2025/04/sports/sports3-9-4-25.jpeg"
                                            className="d-block w-100" alt="Cricket" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpeg/2025/04/sports/sports4-9-4-25.jpeg"
                                            className="d-block w-100" alt="Cricket" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpeg/2025/04/sports/sports5-9-4-25.jpeg"
                                            className="d-block w-100" alt="Cricket" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpeg/2025/04/sports/sports6-9-4-25.jpeg"
                                            className="d-block w-100" alt="Cricket" />
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls4"
                                    data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls4"
                                    data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                <div className="close-btn-modal">
                                    <button data-bs-dismiss="modal" aria-label="Close">
                                        <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-main">
                <div className="modal fade" id="exampleModalToggle5" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                    tabindex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselExampleControls5" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Gym/1.jpg"
                                            className="d-block w-100" alt="Gym" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Gym/2.jpg"
                                            className="d-block w-100" alt="Gym" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Gym/3.jpg"
                                            className="d-block w-100" alt="Gym" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Gym/4.jpg"
                                            className="d-block w-100" alt="Gym" />
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls5"
                                    data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls5"
                                    data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                <div className="close-btn-modal">
                                    <button data-bs-dismiss="modal" aria-label="Close">
                                        <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-main">
                <div className="modal fade" id="exampleModalToggle6" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                    tabindex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselExampleControls6" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Self-Defence/1.jpg"
                                            className="d-block w-100" alt="Self Defence" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Self-Defence/2.jpg"
                                            className="d-block w-100" alt="Self Defence" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Self-Defence/3.jpg"
                                            className="d-block w-100" alt="Self Defence" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Self-Defence/4.jpg"
                                            className="d-block w-100" alt="Self Defence" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Self-Defence/5.jpg"
                                            className="d-block w-100" alt="Self Defence" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Self-Defence/6.jpg"
                                            className="d-block w-100" alt="Self Defence" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Self-Defence/7.jpg"
                                            className="d-block w-100" alt="Self Defence" />
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls6"
                                    data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls6"
                                    data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                <div className="close-btn-modal">
                                    <button data-bs-dismiss="modal" aria-label="Close">
                                        <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-main">
                <div className="modal fade" id="exampleModalToggle7" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                    tabindex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselExampleControls7" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Table-tennis/1.jpg"
                                            className="d-block w-100" alt="Table Tennis" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Table-tennis/2.jpg"
                                            className="d-block w-100" alt="Table Tennis" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Table-tennis/3.jpg"
                                            className="d-block w-100" alt="Table Tennis" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Table-tennis/4.jpg"
                                            className="d-block w-100" alt="Table Tennis" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Table-tennis/5.jpg"
                                            className="d-block w-100" alt="Table Tennis" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Table-tennis/6.jpg"
                                            className="d-block w-100" alt="Table Tennis" />
                                    </div>
                                    <div className="carousel-item">
                                        <img
                                            src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Table-tennis/7.jpg"
                                            className="d-block w-100" alt="Table Tennis" />
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls7"
                                    data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls7"
                                    data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                <div className="close-btn-modal">
                                    <button data-bs-dismiss="modal" aria-label="Close">
                                        <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-main">
                <div className="modal fade" id="exampleModalToggle8" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
                    tabindex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div id="carouselExampleControls8" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-inner">
                                    <div className="carousel-item active">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Yoga/1.jpg"
                                            className="d-block w-100" alt="Yoga" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Yoga/2.jpg"
                                            className="d-block w-100" alt="Yoga" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Yoga/3.jpg"
                                            className="d-block w-100" alt="Yoga" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Yoga/4.jpg"
                                            className="d-block w-100" alt="Yoga" />
                                    </div>
                                    <div className="carousel-item">
                                        <img src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Yoga/5.jpg"
                                            className="d-block w-100" alt="Yoga" />
                                    </div>
                                </div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls8"
                                    data-bs-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls8"
                                    data-bs-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                                <div className="close-btn-modal">
                                    <button data-bs-dismiss="modal" aria-label="Close">
                                        <i className="fa fa-times" aria-hidden="true" style={{ cursor: 'pointer' }}></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;